import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";

@Component({
  selector: "app-car-master",
  templateUrl: "./car-master.component.html",
  styleUrls: ["./car-master.component.css"]
})
export class CarMasterComponent implements OnInit {
  displayValue: Number = 0;
  carlist: any = [];
  vendorData: any = [];
  submitted = false;
  mode: any = "add";
  cardataFm: FormGroup;
  delID: any = [];
  sortKey: string = 'sno'; //set default
  sortReverse: boolean = false;
  noOfItems=10;
  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder
  ) {
    this.getAllData();
    this.getAllVendorData();
  }

  // GET DATA
  getAllData() {
    console.log("Car data getAllData");
    this.awserviceProvider.getCarListAll().then(data => {
      this.constructData(data);
      console.log("response", data);
    });
  }

  constructData(data){
    this.carlist=[]
    var oplist=[]
    for(var i in data){
      data[i].sno=+i+1;
      data[i].ex_data=data[i].ex_data=== 'ASSIGN'?"ASSIGNED":"NOT ASSIGNED";
      oplist.push(data[i])
    }
    this.carlist=oplist;
  }


  getAllVendorData() {
    console.log("vendor Data");
    this.awserviceProvider.getActiveVendorlist().then(data => {
      this.vendorData = data.filter(res => res.vendor_type === "Car");
      // this.vendorData = data;
      console.log("vendor-data", this.vendorData);
    });
  }

  // ADD DATA
  add() {
    this.displayValue = 1;
    this.mode = "add";
    this.formInitilization();
    console.log("this.cardataFm.value", this.cardataFm.value);
  }

  formInitilization() {
    this.cardataFm = this.formBuilder.group({
      id: [""],
      car_model: ["", Validators.required],
      veh_reg_id: ["", Validators.required],
      policy_no: ["", Validators.required],
      policy_from: ["", Validators.required],
      policy_to: ["", Validators.required],
      agency_name: ["", [Validators.required, Validators.min(1)]],
      map_user_id: [""],
      lease_from: ["", Validators.required],
      lease_to: ["", Validators.required]
    });
  }

  get f() {
    return this.cardataFm.controls;
  }

  // EDIT DATA
  editData(cardata) {
    console.log("editData", cardata);
    this.displayValue = 1;
    this.submitted = false;
    this.mode = "edit";
    // this.cardataFm.setValue({
    //   id: cardata.id,
    //   car_model: cardata.car_model,
    //   veh_reg_id: cardata.veh_reg_id,
    //   policy_no: cardata.policy_no,
    //   policy_from: cardata.policy_from,
    //   policy_to: cardata.policy_to,
    //   agency_name: cardata.agency_name,
    //   map_user_id: cardata.map_user_id,
    //   lease_from: cardata.lease_from,
    //   lease_to: cardata.lease_to
    // });
    this.f["id"].setValue(cardata.id);
    this.f["car_model"].setValue(cardata.car_model);
    this.f["veh_reg_id"].setValue(cardata.veh_reg_id);
    this.f["policy_no"].setValue(cardata.policy_no);
    this.f["policy_from"].setValue(cardata.policy_from);
    this.f["policy_to"].setValue(cardata.policy_to);
    this.f["agency_name"].setValue(cardata.agency_name);
    this.f["map_user_id"].setValue(cardata.map_user_id);
    this.f["lease_from"].setValue(cardata.lease_from);
    this.f["lease_to"].setValue(cardata.lease_to);
  }

  // SAVE DATA
  onSubmit() {
    this.submitted = true;
    if (this.cardataFm.invalid) {
      return;
    }
    console.log("Add - car data", this.cardataFm.value.id);
    if (this.cardataFm.value.id !== "") {
      // # UPDATE RECORD #
      this.awserviceProvider
        .UpdateCarData(this.cardataFm.value)
        .then(result => {
          this.getAllData();
          this.displayValue = 0;
        })
        .catch(err => {
          console.log("err", err);
        });
    } else {
      // # CREATE RECORD #
      console.log("car master create");
      this.awserviceProvider
        .CreateCarData(this.cardataFm.value)
        .then(result => {
          console.log("createdata-car", result);
          this.getAllData();
          this.displayValue = 0;
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }

  deletePopup(car) {
    this.delID = car.id;
  }

  // REFER FROM SC-USER-TRIP - (MASTER)
  deleteData(cardata) {
    console.log("cardata", cardata);
    this.awserviceProvider
      .deleteCarData(cardata)
      .then(res => {
        this.delID = "";
        console.log("DeleteID", this.delID);
        this.getAllData();
      })
      .catch(err => {
        console.log(err);
      });
  }

  ngOnInit() {
    this.displayValue = 0;
    this.formInitilization();
    console.log("car data module init");
  }


  public sort(sortKey){
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey){
    if(this.sortKey==sortKey){
      if(this.sortReverse){
        return 'fa fa-sort-desc';
      }
      else
      {
        return 'fa fa-sort-asc';
      }
    }
    else{
      return 'fa fa-sort';
    }
    
  }

}
